<template>
  <div class="thumb circle">
    <a href="javascript:void(0)">
      <div class="thumb-image">
        <template v-if="hasProgress">
          <div class="circle-progress">
            <vue-circle
              :progress="progress * 100"
              :size="160"
              :reverse="false"
              line-cap="butt"
              :fill="fill"
              empty-fill="rgba(0, 0, 0, .1)"
              :animation-start-value="0.0"
              :start-angle="4.7"
              insert-mode="append"
              :thickness="4"
              :show-percent="false">
            </vue-circle>
          </div>
        </template>
          <div class="circle-img">
            <img :src="getLazyLoadingImageObject()" class="thumb-img" :alt="altTitle"/>
            <div :class="adultDimClass"></div>
          </div>
      </div>

      <div class="sub-title">
        <div v-if="hasRank" class="sub-left">
          <div class="num">{{rank}}</div>
        </div>
        <div class="sub-right" v-title-list="{'titleList': titleList}">
        </div>
      </div>
    </a>
  </div>
</template>
<script>
import CellMixIn from '@/mixins/cell.mixin'
import VueCircle from 'vue2-circle-progress/src/index.vue'
import { titleList } from '@/common/resources/directives'
import { setReplaceAll } from '@/common/utils/common'
import _ from 'lodash'
export default {
  name: 'CircleCell',
  directives: {
    titleList
  },
  mixins: [
    CellMixIn
  ],
  components: {
    VueCircle
  },
  props: {
    cellInfo: {
      type: Object
    },
    cellType: {
      type: String
    },
    thumbnailInfo: {
      type: Object
    },
    searchWord: {
      type: String
    }
  },
  data () {
    return {
      fill: { color: '#1351f9' }
    }
  },
  methods: {
    setWordChange (cellInfo) {
      const content = titleList(_.get(cellInfo, 'title_list', []))
      if (this.searchWord) {
        let changeWord = '<span class="col-vari-blue">' + this.searchWord + '</span>'
        return setReplaceAll(content, this.searchWord, changeWord)
      }
      return content
    }
  }
}
</script>

<style scoped>
  .circle{
    width: 160px;
    text-align: center;
    position: relative;
    margin: 0 auto;
  }

  .circle .thumb-image {
    width: 160px;
    height: 160px;
    position: relative;
    overflow: hidden;
    background-color: #252525;
    border-radius: 50%;
    will-change: transform;
    transform: translateZ(0);
  }

  /*.main .circle .thumb-image:hover:after{*/
  /*  position: absolute;*/
  /*  top: 0;*/
  /*  left: 0;*/
  /*  content: '';*/
  /*  display: block;*/
  /*  width: 160px;*/
  /*  height: 160px;*/
  /*  background: url("../../../assets/images/common/main-recent-100.png");*/
  /*}*/

  .circle-progress {
    position: absolute;
    z-index: 100;
    width: 160px;
    height: 160px;
    border-radius: 80px;
    overflow: hidden;
  }

  .circle .thumb-image .circle-img{
    position: relative;
    width: 100%;
    height: 100%;
  }

  .circle .thumb-image .thumb-img{
    position: absolute;
    top: 0;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%);
    height: 100%;
    border: 1px transparent solid;
    border-radius: 80px;
  }
</style>
